<template>
  <form>
    <main class="cf">
      <div class="container">
        <section class="common_section section_message">
          <div class="box cf">
            <h3>メールを送信しました。</h3>
            <p v-html="webContents.article.mailComplate"></p>
          </div>
        </section>
      </div>
    </main>
  </form>
</template>
<script>
export default {
  data() {
    return {
      corpParam: null
    };
  },
  computed: {
    screenId: () => "ENTR_002",
    webContents() {
      let ret = {};
      if (this.corpParam) {
        ret = JSON.parse(this.corpParam.memberRegistrationWebContents)[
          this.screenId
        ];
      }
      return ret;
    }
  },
  created() {
    this.corpParam = JSON.parse(localStorage.getItem("corpParam"));
  }
};
</script>
